
import globals from '../globals';
import ManageShoppingCartService from './manage-shopping-cart-service';

import agilOneMixin from '../../common/mixins/agilone-mixin';

class CartUpdate {
  manageShoppingCartService = new ManageShoppingCartService()


  callShoppingCart() {
    const requestConfig = {};
    this.manageShoppingCartService.getFullCartService(requestConfig, this.handleShoppingCartResponse, this.handleShoppingCartError);
    // this.spinnerComponent.showSpinner();
  }

  // eslint-disable-next-line class-methods-use-this
  handleShoppingCartResponse(res) {
    let product = {};
    const prodsInfo = [];
    const productsInCart = res.data.entries;

    productsInCart.forEach((currentVal) => {
      product.SourceProductNumber = `BID=${globals.siteId}&SPN=${currentVal.product.code}`;
      product.quantity = currentVal.quantity;
      prodsInfo.push(product);
      product = {};
    });
    agilOneMixin.methods.trackAddToCart(prodsInfo);
  }
}


export default CartUpdate;




// WEBPACK FOOTER //
// ./src/components/common/services/cart-update-service.js